import { Component, OnInit, ElementRef, Renderer2 } from '@angular/core';
import { WidgetComponent } from '../widget/widget.component';
import { TableComponent } from '../table.component';
import { TableElement } from '../table.element';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ButtonComponentEvent } from '../button/button.component';

@Component({
  selector: 'app-table-widget-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss']
})
export class RadioComponent extends WidgetComponent implements OnInit {

  identifier = '';

  // tslint:disable-next-line: deprecation
  constructor(ngEl: ElementRef, renderer: Renderer2) {
    super(ngEl, renderer);
  }

  ngOnInit() {
  }

  public setContent(table: TableComponent, tableElement: TableElement, tableColumn: any): void {
    super.setContent(table, tableElement, tableColumn);

    this.identifier = tableElement.id();
  }

  checkSelected(): boolean {
    if (this.table && this.table._activeRow && this.identifier && this.identifier === this.table._activeRow.id()) {
      this.tableElement.setSelected(true);
      return true;
    } else if (this.table && this.table.activeRowId && this.identifier === this.table.activeRowId) {
      this.tableElement.setSelected(true);
      return true;
    } else if (this.table && this.table._activeRow && this.table._activeRow.getData() === this.tableElement.getData()) {
      this.tableElement.setSelected(true);
      return true;
    } else {
      this.tableElement.setSelected(false);
      return false;
    }
  }

  setChange($event: MatCheckboxChange): void {
    this.table.resetSelectState();
    this.table.activeRowId = this.tableElement.id();
    this.tableElement.setSelected($event.source.checked);

    this.table.onButtonClicked(new ButtonComponentEvent(this.tableElement, this.tableColumn));
  }

  onClicked($event: any): void {
    $event.stopPropagation();
  }
}
